import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppConfig } from '../config/app-config';

/** Dead-end screen shown on a phone browser unless the CMS `isMobileBrowserBlocked` kill-switch is strictly `false`. */
@Component({
  selector: 'app-unsupported-device',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div class="app-min-viewport flex flex-col items-center justify-center bg-primary px-6 text-center">
      <div class="max-w-md rounded-2xl border border-border-overlay bg-surface p-10 shadow-xl">
        <div class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-accent">
          <svg class="h-9 w-9 text-text-main" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25A2.25 2.25 0 015.25 3h13.5A2.25 2.25 0 0121 5.25z"
            />
          </svg>
        </div>
        <h2 class="mb-2 text-xl font-bold text-text-main">{{ 'common.unsupportedDevice.title' | translate }}</h2>
        <p class="text-sm leading-relaxed text-text-secondary">
          {{ 'common.unsupportedDevice.body' | translate: { appName } }}
        </p>
      </div>
    </div>
  `,
})
export class UnsupportedDeviceComponent {
  readonly appName = AppConfig.JIO_CLOUD_PC_APP_NAME;
}
